/** Legacy auto-select/export treats strong tag matches as perfect (>= 95%). */
export function isPerfectLocalMatch(matchScore?: number): boolean {
  return matchScore !== undefined && matchScore >= 95;
}
